export default __webpack_public_path__ + "static/media/logout.a9a41415.svg";